const editStaffPage = () =>
  import('@/views/main/staff/base-ui/edit-staff/edit-staff.vue')
export default {
  path: '/main/staff/editStaffPage',
  name: 'editStaffPage',
  component: editStaffPage,
  children: []
}
